// import div from "components/Base/BoxComponent";
// import img from "components/Base/img";
// import p from "components/Base/TypographyComponent";
// import { toActualDate } from "utils/Helpers";
import { useState } from "react";
// import TextFieldComponent from "components/Base/TextFieldComponent";
// import { inquiryReply, submittInquiry } from "utils/API";
// import StatusAlertSnackbarComponent from "components/UseCase/Common/StatusAlertSnackbarComponent";
// import { STATUS_ALERT_SNACKBAR_SUCCESS } from "utils/Constant";
// import AvatarComponent from "components/Base/AvatarComponent";
import { Input } from "reactstrap";
import sendIcon from "../assets/img/send.png";

const noImage = "/common/no-profile-picture.svg";

export default function InquiryChat({
  setOpen,
  setShowUser,
  data,
  handleCall,
  isAgent,
}) {
  const [message, setMessage] = useState([
    {
      id: 1,
      message: "abc",
    },
  ]);
  const [isAlert, setIsAlert] = useState(false);

  let payload = {
    type: "inquiry",
    inquirableId: data && data[Object.keys(data)]?.inquiry[0]?.inquirableId,
    name: data && data[Object.keys(data)]?.userData?.name,
    phone: data && data[Object.keys(data)]?.userData?.phone_number,
    inquirableType: "property",
    userId: data && data[Object.keys(data)]?.inquiry[0]?.userId,
    screenSize: `${window.innerWidth}*${window.innerHeight}`,
  };

  const sendReply = (event) => {
    // if (message != "") {
    //   const id = data && data[Object.keys(data)]?.inquiry[0]?.id;
    //   payload = { ...payload, message: message };
    //   if (isAgent) {
    //     inquiryReply(id, message);
    //   } else {
    //     submittInquiry(payload);
    //   }
    //   setIsAlert(true);
    //   setMessage("");
    // }
    // event.stopPropagation();
  };

  const getStyling = (item) => {
    const isAgentStyle = item.inquirableId ? styles.scroll : styles.scrollRep;
    const isUserStyle = !item.inquirableId ? styles.scroll : styles.scrollRep;

    if (isAgent) {
      return isAgentStyle;
    }

    return isUserStyle;
  };

  return (
    <div style={styles.mainBox}>
      <div style={{ ...styles.grey, ...styles.topContainer }}>
        <div style={styles.flex}>
          {/* <img
            source="/common/backArrow.svg"
            alt="back"
            style={styles.backIcon}
            onClick={() => setOpen(false)}
          /> */}

          <div
            style={{ ...styles.cursor, ...styles.flex }}
            onClick={() => setShowUser(true)}
          >
            {/* <AvatarComponent
              src={
                (isAgent
                  ? (data &&
                      data[Object.keys(data)]?.userData?.[
                        "custom:profile_url"
                      ]) ||
                    (data && data[Object.keys(data)].inquiry[0].image)
                  : data &&
                    data[Object.keys(data)]?.onwerInfo?.profile_image) ||
                noImage
              }
              alt="home"
              style={styles.avatar}
            /> */}

            <p variant="subtitle1New" component="h5">
              {isAgent
                ? data && data[Object.keys(data)]?.inquiry[0]?.name
                : data && data[Object.keys(data)]?.onwerInfo?.name}
            </p>
          </div>
        </div>

        {/* <img
          source="/gpm/call.svg"
          alt="call"
          style={styles.crossIcon}
          onClick={() =>
            handleCall(
              isAgent
                ? data && data[Object.keys(data)]?.inquiry[0]?.phone
                : data && data[Object.keys(data)]?.onwerInfo?.phone_number
            )
          }
        /> */}
      </div>

      <div style={styles.scrollContainer}>
        {data &&
          data[Object.keys(data)].inquiry.map((item, index) => (
            <div style={getStyling(item)} key={index}>
              <p variant="body2New" style={styles.msg}>
                {item.message}
              </p>
              <p variant="captionNew" style={styles.time}>
                {!isAgent
                  ? !item.inquirableId
                    ? "Received "
                    : "Sent "
                  : !item.inquirableId
                  ? "Sent "
                  : "Received "}
                {/* {toActualDate(item.createdAt)} */}
              </p>
            </div>
          ))}
      </div>

      <div style={{ ...styles.grey, ...styles.textFieldContainer }}>
        {/* {isAlert && (
          <StatusAlertSnackbarComponent
            message={`Message has been sent.`}
            open={isAlert}
            onClose={() => setIsAlert(false)}
            status={STATUS_ALERT_SNACKBAR_SUCCESS}
            placementBottom
          />
        )} */}
        <Input
          placeholder="Type your message here.."
          style={styles.textField}
          value={message}
          onInputChange={setMessage}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              sendReply(e);
            }
          }}
        />
        <img
          src={sendIcon}
          alt="send"
          style={styles.sendIcon}
          onClick={(e) => sendReply(e)}
        />
      </div>
    </div>
  );
}
export const styles = {
  mainBox: {
    background: "white",
    border: "1px solid #F2F2F2",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    "@media (max-width: 600px)": {
      height: "100%",
    },
  },
  crossIcon: {
    width: "17px",
    height: "17px",
    cursor: "pointer",
  },
  avatar: {
    width: "36px",
    height: "36px",
  },
  msg: {
    color: "#737678",
  },
  time: {
    color: "#BBBBBB",
  },
  scroll: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    maxWidth: "400px",
    border: "1px solid #F2F2F2",
    borderRadius: "0px 8px 8px 8px",
    background: "#FFFFFF",
    padding: "5px",
  },
  scrollRep: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    maxWidth: "400px",
    borderRadius: "8px 8px 0px 8px",
    background: "#F2F2F2",
    padding: "5px",
    textAlign: "right",
    alignSelf: "flex-end",
  },
  scrollContainer: {
    padding: "20px 60px",
    height: "515px",
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",
    gap: "5px",
    width: "100%",
  },
  textFieldContainer: {
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    width: "100%",
    gap: "16px",
  },
  grey: {
    backgroundColor: "#F2F2F2",
  },
  callIcon: {
    width: "14px",
    height: "14px",
  },
  callButton: {
    display: "flex",
    gap: "10px",
    width: "100%",
    height: "40px",
    boxShadow: "none",
    ":hover": { boxShadow: "none", backgroundColor: "#37474F" },
  },
  divider: {
    height: "2px",
    width: "100%",
    marginBottom: "20px",
  },
  topContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "10px 18px",
  },
  mobileHeader: {
    width: "100%",
  },
  noLinkStyle: {
    textDecoration: "none",
    width: "100%",
  },
  textField: {
    "& fieldset": { border: "none" },
    height: "36px",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    fontWeight: 400,
    fontSize: "11.64px",
    lineHeight: "19.8px",
  },
  sendIcon: { width: "18px", height: "18px", cursor: "pointer" },
  cursor: { cursor: "pointer" },
  backIcon: {
    width: "7px",
    height: "14px",
    "@media (min-width: 600px)": {
      display: "none",
    },
  },
  flex: { display: "flex", alignItems: "center", gap: "10px" },
};
